import { createSlice } from '@reduxjs/toolkit';

// @TODO: This needs a lot of work given the useAuth Hook now.
export const initialState = {
	user: {},
	challenge: {
		name: undefined,
		isValidated: false,
		isValidating: false,
		error: undefined
	},
	hasBeenLoaded: false,
	isAuthed: false,
	isAuthingUser: false,
	logInError: '',
	mfaCode: {
		code: undefined,
		error: undefined,
		hasBeenLoaded: false,
		isLoading: false,
		setupString: undefined
	},
	mfa: {
		error: undefined,
		isLoading: false
	},
	mfaPreference: undefined,
	invalidateAuth: {
		error: undefined,
		hasBeenLoaded: false,
		isLoading: false
	}
};

export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		invalidateAuth: (state) => {
			state.invalidateAuth.isLoading = true;
		},
		invalidateAuthCompleted: (state) => {
			state.invalidateAuth.hasBeenLoaded = true;
			state.invalidateAuth.isLoading = false;
		},
		invalidateAuthFailed: (state, action) => {
			state.invalidateAuth.error = action.payload;
			state.invalidateAuth.hasBeenLoaded = true;
			state.invalidateAuth.isLoading = false;
		},
		authUser: (state) => {
			state.isAuthingUser = true;
		},
		authUserCompleted: (state, action) => {
			state.isAuthingUser = false;
			state.user = action.payload;
			state.mfaPreference = action.payload.preferredMFA;
			state.hasBeenLoaded = true;
			state.isAuthed = true;
			state.logInError = '';
		},
		authUserFailed: (state, action) => {
			state.isAuthingUser = false;
			state.hasBeenLoaded = true;
			state.isAuthed = false;
			state.logInError = action.payload;
		},
		authUserClear: (state) => {
			state.user = {};
			state.challenge = initialState.challenge;
			state.isAuthingUser = false;
			state.isAuthed = false;
			state.logInError = '';
		},
		authUserLoginFailure: (state, action) => {
			state.isAuthingUser = false;
			state.isAuthed = false;
			state.logInError = action.payload;
		},
		authUserChallenge: (state, action) => {
			state.challenge.name = action.payload.challengeName;
			state.challenge.isSet = false;
			state.user = action.payload.user;
		},
		authUserValidateMfa: (state) => {
			state.challenge.isValidated = false;
			state.challenge.isValidating = true;
			state.challenge.error = undefined;
		},
		authUserValidateMfaCompleted: (state) => {
			state.challenge.isValidated = true;
			state.challenge.isValidating = false;
			state.challenge.error = undefined;
		},
		authUserValidateMfaFailed: (state, action) => {
			state.challenge.isValidated = false;
			state.challenge.isValidating = false;
			state.challenge.error = action.payload;
		},
		getMfaSetupCode: (state) => {
			state.mfaCode.hasBeenLoaded = false;
			state.mfaCode.isLoading = true;
			state.mfaCode.error = undefined;
		},
		getMfaSetupCodeCompleted: (state, action) => {
			state.mfaCode.hasBeenLoaded = true;
			state.mfaCode.isLoading = false;
			state.mfaCode.code = action.payload.code;
			state.mfaCode.setupString = action.payload.setupString;
			state.mfaCode.error = undefined;
		},
		getMfaSetupCodeFailed: (state, action) => {
			state.mfaCode.hasBeenLoaded = false;
			state.mfaCode.isLoading = false;
			state.mfaCode.code = undefined;
			state.mfaCode.setupString = undefined;
			state.mfaCode.error = action.payload;
		},
		activateMfa: (state) => {
			state.mfa.isLoading = true;
			state.mfa.error = undefined;
		},
		activateMfaCompleted: (state, action) => {
			state.mfa.isLoading = false;
			state.user = action.payload;
			state.mfaPreference = action.payload.preferredMFA;
			state.mfa.error = undefined;
		},
		activateMfaFailed: (state, action) => {
			state.mfa.isLoading = false;
			state.mfa.error = action.payload;
		},
		deactivateMfa: (state) => {
			state.mfa.isLoading = true;
			state.mfa.error = undefined;
		},
		deactivateMfaCompleted: (state, action) => {
			state.mfa.isLoading = false;
			state.user = action.payload;
			state.mfaPreference = action.payload.preferredMFA;
			state.mfa.error = undefined;
		},
		deactivateMfaFailed: (state, action) => {
			state.mfa.isLoading = false;
			state.mfa.error = action.payload;
		}
	}
});

export const {
	authUser,
	authUserCompleted,
	authUserFailed,
	authUserClear,
	authUserLoginFailure,
	authUserChallenge,
	authUserValidateMfa,
	authUserValidateMfaCompleted,
	authUserValidateMfaFailed,
	getMfaSetupCode,
	getMfaSetupCodeCompleted,
	getMfaSetupCodeFailed,
	activateMfa,
	activateMfaCompleted,
	activateMfaFailed,
	deactivateMfa,
	deactivateMfaCompleted,
	deactivateMfaFailed,
	invalidateAuth,
	invalidateAuthCompleted,
	invalidateAuthFailed
} = authSlice.actions;

export default authSlice.reducer;
